import {useMutation} from '@tanstack/react-query';
import {postDeclineWellBornProgram} from '../../services/postDeclineWellBornProgram';

export function useDeclineWellBornProgramMutation() {
	return useMutation({
		mutationFn: postDeclineWellBornProgram,
	});
}
